import React from "react";

const indexIcon = (indexImage, indexProgress) =>
  `./Icono${
    indexImage <= indexProgress + 1 ? indexImage + 10 : indexImage
  }.svg`;
const styleText = (indexText, indexProgress) =>
  (indexText = indexProgress ? "" : "");

const getImg = (width = 75, className, indexProgress, indexImage) => (
  <img
    width={width}
    className={className}
    src={require(`${indexIcon(indexImage, indexProgress)}`).default}
    alt="imagen"
  />
);

export const Img1 = ({ width = 75, className }) => (
  <img
    width={width}
    className={className}
    src={require(`./Icono1.svg`).default}
    alt="imagen"
  />
);
export const Img2 = ({ width = 75, className, indexProgress }) =>
  getImg(width, className, indexProgress, 2);
export const Img3 = ({ width = 75, className, indexProgress }) =>
  getImg(width, className, indexProgress, 3);

export const ImgAlert = ({ width = 75 }) => (
  <img width={width} src={require(`../IconoAlert.png`).default} alt="imagen" />
);

export const ImgAlertOk = ({ width = 75 }) => (
  <img
    width={width}
    src={require(`../IconoAlertOk.png`).default}
    alt="imagen"
  />
);

export const ImgAlertCallCenter = ({ width = 75 }) => (
  <img
    width={width}
    src={require(`../ImgAlertCallCenter.png`).default}
    alt="imagen"
  />
);

export const ImgNext = ({ width = 16 }) => (
  <img width={width} src={require(`../arrow-right.png`).default} alt="imagen" />
);

export const ImgEmailOK = ({ width = 75 }) => (
  <img width={width} src={require(`./Icono4.svg`).default} alt="imagen" />
);
export const ImgEmailFail = ({ width = 75 }) => (
  <img width={width} src={require(`./Icono5.svg`).default} alt="imagen" />
);
export const ImgInfo = ({ width = 15 }) => (
  <img width={width} src={require(`./IconoInfo.png`).default} alt="imagen" />
);
